import { Building2, UserCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import type { UserType } from '@/lib/types/registration';

// Re-export for convenience
export { UserType };

interface UserTypeSelectorProps {
  onSelect: (type: UserType) => void;
  isLoading?: boolean;
}

export function UserTypeSelector({ onSelect, isLoading }: UserTypeSelectorProps) {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-semibold text-foreground">
          Welcome to Dominion Mandate Platform
        </h2>
        <p className="text-muted-foreground">
          Please select your membership type to continue
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {/* DC Member Option */}
        <Card 
          className="cursor-pointer transition-all duration-200 hover:border-primary hover:shadow-md"
          onClick={() => !isLoading && onSelect('dc_member')}
        >
          <CardContent className="p-6">
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="p-3 rounded-full bg-primary/10">
                <UserCheck className="h-8 w-8 text-primary" />
              </div>
              <div className="space-y-2">
                <h3 className="font-semibold text-lg">I am a DC Member</h3>
                <p className="text-sm text-muted-foreground">
                  I am a member of Dominion Mandate church
                </p>
              </div>
              <Button 
                variant="outline" 
                className="w-full"
                disabled={isLoading}
              >
                Select
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Non-DC Member Option */}
        <Card 
          className="cursor-pointer transition-all duration-200 hover:border-primary hover:shadow-md"
          onClick={() => !isLoading && onSelect('visitor')}
        >
          <CardContent className="p-6">
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="p-3 rounded-full bg-warning/20">
                <Building2 className="h-8 w-8 text-warning" />
              </div>
              <div className="space-y-2">
                <h3 className="font-semibold text-lg">I am NOT a DC Member</h3>
                <p className="text-sm text-muted-foreground">
                  I am from another ministry or church
                </p>
              </div>
              <Button 
                variant="outline" 
                className="w-full"
                disabled={isLoading}
              >
                Select
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="text-center text-sm text-muted-foreground">
        <p>Already have an account?{' '}
          <a href="/signin" className="text-primary hover:underline">
            Sign in here
          </a>
        </p>
      </div>
    </div>
  );
}
